<template>
  <div>
    <card>
      <div class="card-header-custom">
        <button type="submit" class="btn btn-fill btn-primary mr-2"
          @click="$router.push('/warehouses/create')"
          v-if="isAllowedToAdd"
        >
          <i class="fa fa-plus"></i> Hinzufügen
        </button>

        <button class="btn btn-success" @click="$router.push('/warehouses/restore')">
            <i class="fa fa-recycle"></i>
            Gelöschte Lager
          </button>
      </div>
      <div class="row">
        <div class="col-sm-6">
            <label>Standort</label>
          <div class="form-group has-label">
            <multiselect v-model="selectedLocations"
              :options="locations"
              :multiple="true"
              track-by="id"
              label="name"
              @input="filterData"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <transition name="el-fade-in-linear">
            <div style="overflow-x: auto; margin-top: 0.75em;">
            <table class="table table-striped table-bordered" v-if="warehouses.length">
              <thead>
                <tr>
                  <th width="10px">&nbsp;</th>
                  <th>Kurzname</th>
                  <th>Name</th>
                  <th>Standort</th>
                  <th>Straße</th>
                  <th>PLZ</th>
                  <th>Ort</th>
                  <th class="text-center">Produkte</th>
                  <th v-if="isAllowedToEdit">&nbsp;</th>
                </tr>
              </thead>
              <draggable v-model="warehouses" tag="tbody" handle=".handle"
                @end="updateOrder"
              >
                <tr v-for="warehouse in warehouses" :key="warehouse.id">
                  <td class="handle"><i class="fas fa-arrows-alt-v"></i></td>
                  <td v-text="warehouse.short_name"></td>
                  <td v-text="warehouse.name"></td>
                  <td>
                    <router-link :to="`/locations/${warehouse.location.id}/products`" v-if="warehouse.location">
                      {{ warehouse.location.name }}
                    </router-link>
                  </td>
                  <td v-text="warehouse.street"></td>
                  <td v-text="warehouse.zip"></td>
                  <td v-text="warehouse.place"></td>
                  <td class="text-center">
                    <a v-tooltip.top-center="'Produkte'" class="btn btn-info btn-link btn-xs"
                      @click="$router.push(`/warehouses/${warehouse.id}/products`)"
                    >
                      <i class="fas fa-boxes" aria-hidden="true"></i>
                    </a>
                    <a v-tooltip.top-center="'Zu bestellende Produkte'" class="btn btn-info btn-link btn-xs"
                      @click="$router.push(`/warehouses/${warehouse.id}/products/to_order`)"
                    >
                      <i class="fas fa-shopping-cart" aria-hidden="true"></i>
                    </a>
                    <a v-tooltip.bottom="'Warnschwellen & Sollmengen konfigurieren'" class="btn btn-warning btn-link btn-xs"
                      @click="$router.push(`/warehouses/${warehouse.id}/product_config`)"
                    >
                      <i class="fas fa-cogs"></i>
                    </a>
                  </td>
                  <td class="text-right" v-if="isAllowedToEdit">
                    <div class="td-actions">
                      <a v-tooltip.top-center="'Bearbeiten'" class="btn btn-warning btn-link btn-xs"
                         @click="editWarehouse(warehouse)">
                        <i class="fa fa-edit"></i>
                      </a>
                      <a v-if="warehouses.length !== 1" v-tooltip.top-center="'Löschen'" class="btn btn-danger btn-link btn-xs"
                         @click="deleteWarehouse(warehouse)">
                        <i class="fa fa-close"></i>
                      </a>
                    </div>
                  </td>
                </tr>
              </draggable>
            </table>
            </div>
          </transition>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: { draggable },
  data () {
    return {
      warehouses: [],
      locations: [],
      selectedLocations: []
    }
  },
  computed: {
    isAllowedToAdd () {
      return !this.$store.getters.isFrontdesk
    },
    isAllowedToEdit () {
      return !this.$store.getters.isFrontdesk
    }
  },
  methods: {
    editWarehouse (warehouse) {
      this.$router.push(`/warehouses/${warehouse.id}/edit`)
    },
    async deleteWarehouse (warehouse) {
      if (confirm(`Lager ${warehouse.name} wirklich löschen?`)) {
        await this.initCsrf()

        this.$http.delete(`/warehouses/${warehouse.id}`).then(({ data }) => {
          this.$notify({
            message: `Lager ${data.name} erfolgreich gelöscht.`,
            type: 'success'
          })
          const index = this.warehouses.findIndex(({ id }) => data.id === id)
          this.warehouses.splice(index, 1)
        })
      }
    },
    async updateOrder () {
      await this.initCsrf()

      const warehouses = this.warehouses.reduce((warehouses, warehouse, idx) => ({ ...warehouses, [warehouse.id]: idx }), {})
      this.$http.put(`/warehouses`, { warehouses })
    },
    filterData () {
      this.getData(new URLSearchParams({
        locations: this.selectedLocations.map(({ id }) => id)
      }).toString())
    },
    getData (query) {
      this.$http.get(`/warehouses?${query}`).then(({ data }) => {
        this.warehouses = data
      })
    }
  },
  created () {
    this.getData()
    this.$http.get('/locations').then(({ data }) => { this.locations = data })
  }
}
</script>
